module.exports = __webpack_public_path__ + "static/media/GongXiang3.5e8ef18a.png";